
// import { Chart } from 'primereact/chart';
import { Chart } from 'chart.js';
import { useState } from 'react';
import { ChartCustom } from './styles';

export interface IChartComponents { 
    labels: any[]
    datasets: { 
        data: number[]
        backgroundColor: string[]
        cutout: string,
        total: number,
        fontSize: number,
    }

}

export const DashboardChart: React.FC<IChartComponents> = ({ labels, datasets }) => { 
    const [chartData] = useState({
        labels: labels,
        borderWidth: 3,
        datasets: [ datasets ]
    });

    const [lightOptions] = useState({
        plugins: {
            maintainAspectRatio: false,
            responsive: false,  
                   
            legend: {
                onClick: () => {},
                position: 'bottom',
                labels: {
                    usePointStyle: true,   
                    pointStyle: true,               
                    color: '#333333',
                    boxWidth: 10,
                    font: { 
                        size: '13%'
                    }
                }
            },
        }
    });

    // Background String at Doughnut Chart

    const plugin = { 
        beforeDraw: (chart: Chart) => {
            const ctx = chart.ctx;
            const {top, width, height} = chart.chartArea;
            const x = (width / 2) ;
            const y = top + height / 2 ;
            ctx.restore();
            ctx.font = "24px sans-serif";
            ctx.fillText(datasets.total.toString(), x, y);
            // ctx.fillText('3000', x, y);
            ctx.textAlign = 'center';
            ctx.textBaseline = "middle"
            ctx.save();
        }
    }

    return ( 
        <ChartCustom type="doughnut" data={chartData} options={lightOptions} plugins={[plugin]}  style={{ position: 'relative', width: '100%', maxWidth: '300px', margin: 'auto' }} />
    )
}